// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JgXr","title":"styles_title__3l6pS"};